
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autopay",
      function () {
        return require("private-next-pages/autopay/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autopay"])
      });
    }
  